import { ActionType, createAsyncAction } from "typesafe-actions";

import BoundaryLegend, {
  CreateBoundaryLegendPayload,
  UpdateBoundaryLegendPayload,
} from "@mapmycustomers/shared/types/map/BoundaryLegend";

export const fetchBoundaryLegends = createAsyncAction(
  "@boundaryLegends/fetch/request",
  "@boundaryLegends/fetch/success",
  "@boundaryLegends/fetch/failure"
)<{ force: true } | void, BoundaryLegend[], unknown>();

export const createBoundaryLegend = createAsyncAction(
  "@boundaryLegends/createBoundaryLegend/request",
  "@boundaryLegends/createBoundaryLegend/success",
  "@boundaryLegends/createBoundaryLegend/failure"
)<
  {
    callback?: (boundaryLegend: BoundaryLegend) => void;
    payload: CreateBoundaryLegendPayload;
  },
  BoundaryLegend,
  unknown
>();

export const updateBoundaryLegend = createAsyncAction(
  "@boundaryLegends/updateBoundaryLegend/request",
  "@boundaryLegends/updateBoundaryLegend/success",
  "@boundaryLegends/updateBoundaryLegend/failure"
)<
  {
    callback?: (pinLegend: BoundaryLegend) => void;
    payload: UpdateBoundaryLegendPayload;
  },
  BoundaryLegend,
  unknown
>();

export const deleteBoundaryLegend = createAsyncAction(
  "@boundaryLegends/delete/request",
  "@boundaryLegends/delete/success",
  "@boundaryLegends/delete/failure"
)<
  {
    boundaryLegendId: BoundaryLegend["id"];
    callback?: () => void;
  },
  BoundaryLegend["id"],
  unknown
>();

export type Actions = ActionType<
  | typeof createBoundaryLegend
  | typeof deleteBoundaryLegend
  | typeof fetchBoundaryLegends
  | typeof updateBoundaryLegend
>;
